import type { Moment } from 'moment'
import moment from 'moment'

export const computeShiftDates = (timeRange: string[], momentDate: Moment) => {
  const [startsAt, endsAt] = timeRange
  const startTime = moment(startsAt, 'HH:mm')
  const endTime = moment(endsAt, 'HH:mm')

  const endShiftIsDayAfter = startTime > endTime

  const startDate = momentDate.clone().set({
    hour: startTime.get('hour'),
    minute: startTime.get('minute')
  })
  const endDate = momentDate
    .clone()
    .add(endShiftIsDayAfter ? 1 : 0, 'days')
    .set({
      hour: endTime.get('hour'),
      minute: endTime.get('minute')
    })

  return { endShiftIsDayAfter, startDate, endDate }
}
